import { IAbUseExperiment } from '../../types/abUseExperiments';

const initialState: IAbUseExperiment[] = [];

export function abUseExperimentsReducer(state = initialState): IAbUseExperiment[] {
  return state;
}
